import { useEffect, useRef, useState } from "react";
import { CaretDownOutline, CaretUpOutline } from "react-ionicons";

import frenshFlag from "../assets/flags/fr.svg";
import englishFlag from "../assets/flags/en.svg";
import { useTranslation } from "react-i18next";

interface LangSelectorProps {
  selectedLang: string;
  onSelectLang: (lang: string) => void;
}

function LangSelector({ selectedLang, onSelectLang }: LangSelectorProps) {
  const { t } = useTranslation("global");
  
  const supportedLangs = [
    {
      name: t("languages.frensh"),
      code: "fr",
      flag: frenshFlag,
    },
    {
      name: t("languages.english"),
      code: "en",
      flag: englishFlag,
    },
  ];
  
  let selectedLangObj = supportedLangs.find(
    (lang) => lang.code == selectedLang
  );
  
  const [isOpen, setOpen] = useState(false);
  
  const onClick = () => {
    setOpen((prev) => !prev);
  };
  
  const langSelectorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.addEventListener("mousedown", clickOutSideHandler);
    
    return () => {
      document.removeEventListener("mousedown", clickOutSideHandler);
    };
  }, []);
  
  const clickOutSideHandler = (event: MouseEvent) => {
    if (
      langSelectorRef.current &&
      !langSelectorRef.current?.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };
  useEffect(() => {
    localStorage.setItem("langue","French")
  }, [1]);
  return (
    <div className="relative" ref={langSelectorRef}>
      <button
        onClick={onClick}
        className="w-32 h-14 rounded-md flex flex-row items-center justify-evenly"
        aria-label={`Select language. Current language: ${selectedLangObj?.name}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="w-6 h-4">
          <img
            src={selectedLangObj?.flag}
            className="rounded-md object-cover"
            alt={`${selectedLangObj?.name} flag`}
          />
        </div>
        {/* <span className="font-heading  text-black">
          {selectedLangObj?.name}
        </span> */}
        {isOpen ? (
          <CaretUpOutline
            color={"#2563EB"}
            title={"Close language menu"}
            height="15px"
            width="15px"
          />
        ) : (
          <CaretDownOutline
            color={"#2563EB"}
            title={"Open language menu"}
            height="15px"
            width="15px"
          />
        )}
      </button>
      <div
        className={`absolute bg-white z-10 py-3 w-full rounded-md shadow-md top-10 ${
          !isOpen && "hidden"
        } `}
        role="menu"
        aria-labelledby="language-selector"
      >
        {supportedLangs.map((lang) => {
          return (
            <div
              onClick={() => {
                setOpen((prev) => !prev);
                onSelectLang(lang.code);
                localStorage.setItem("langue", lang?.name);
              }}
              className={`flex flex-row items-center justify-between px-4 h-9 cursor-pointer rounded-r-md hover:bg-primary-light ${
                lang.code == selectedLang ? "border-l-2 border-primary" : ""
              }`} 
              key={lang.code}
              role="menuitem"
            >
              <div className="w-6 h-4">
                <img
                  src={lang?.flag}
                  className="rounded-md object-cover"
                  alt={`${lang?.name} flag`}
                />
              </div>
              <span className="font-heading text-black">{lang?.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LangSelector;